export const REACT_APP_DISCORD_BOT_ENDPOINT = process.env.REACT_APP_DISCORD_BOT_ENDPOINT || 'http://localhost:3501';